export const REPUTATION_PAGE_THEME = 'warning';

export const REPUTATION_SECTION_THEMES = {
    overview: 'warning',
    shortCode: 'cyan',
    activity: 'purple',
    links: 'cyan',
    comments: 'purple',
    feedback: 'success',
};

export const REPUTATION_STAT_THEMES = {
    links: 'cyan',
    comments: 'purple',
    feedback: 'success',
    shortCode: 'warning',
};

export const REPUTATION_AVATAR_THEMES = [
    'warning',
    'cyan',
    'purple',
    'success',
    'pink',
    'indigo',
    'teal',
    'orange',
];

export const getReputationAvatarTheme = (id, index = 0) => {
    if (!id) {
        return REPUTATION_AVATAR_THEMES[index % REPUTATION_AVATAR_THEMES.length];
    }

    let hash = 0;

    for (let i = 0; i < String(id).length; i += 1) {
        hash = String(id).charCodeAt(i) + ((hash << 5) - hash);
    }

    return REPUTATION_AVATAR_THEMES[Math.abs(hash) % REPUTATION_AVATAR_THEMES.length];
};
